import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Pdf.module.css';
import classNames from 'classnames';

const OutlineItem = ({ outlineItem, onOutlineItemClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const onClickHandler = (e) => {
    e.preventDefault();
    onOutlineItemClick(outlineItem.dest);
  };

  const onTreeItemToggleClick = (e) => {
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.treeItem}>
      {outlineItem.items && outlineItem.items.length > 0 && (
        <div
          className={classNames(styles.treeItemToggler, {
            [styles.treeItemsHidden]: !isExpanded,
          })}
          onClick={onTreeItemToggleClick}
          role='button'
        ></div>
      )}
      <a href="/" onClick={onClickHandler}>
        {outlineItem.title}
      </a>
      {outlineItem.items && outlineItem.items.length > 0 && (
        <div className={styles.treeItems}>
          {outlineItem.items.map((item, index) => (
            <OutlineItem
              key={item.title || item.dest || `item-${index}`}
              outlineItem={item}
              onOutlineItemClick={onOutlineItemClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

OutlineItem.propTypes = {
  outlineItem: PropTypes.shape({
    title: PropTypes.string.isRequired,
    dest: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ]),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        dest: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.array
        ]),
        items: PropTypes.array // Recursive structure for nested items
      })
    )
  }).isRequired,
  onOutlineItemClick: PropTypes.func.isRequired
};

export default OutlineItem;
